// extracted by mini-css-extract-plugin
export default {"labelCell":"styles_labelCell__B14CZ"};